<template>
  <WsUpdate
    :modelName="modelName"
    :id="$route.params.id"
    :localeMode="localeMode"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    titleKey="remark"
  >
  </WsUpdate>
</template>

<script>
import model from "@/models/legal_inquiry";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    localeMode: true,
    fields: model.fields,
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          hideOnNull: false,
          floors: [
            {
              fields: [
                "factory",
                "contact_person",
                "contact_way",
                "tel",
                "email",
                "contact_for",
                "remark",
                "attaches",
                "acts",
                "assignee",
                "status",
                "status_remark",
              ],
            },
          ],
        },
      ],
    },
  }),
};
</script>